import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import { FooterLinksStack } from './FooterLinks.styles';
import LinkGroup from './LinkGroup';
import GooglePlayBadge from 'molecules/AppStoreBadges/GooglePlayBadge';
import AppStoreBadge from 'molecules/AppStoreBadges/AppStoreBadge';
import {
  LinkGroup as LinkGroupType,
  PRODUCT_LINKS,
  MIGHTY_PRO_LINKS,
  RESOURCES_LINKS,
  COMPANY_LINKS,
  COMPARISON_LINKS,
} from './FooterLinkData';

const FooterLinks = (): JSX.Element => {
  const renderLinkGroups = (linkGroups: LinkGroupType[]) => {
    return linkGroups.map((linkGroup) => (
      <LinkGroup
        key={`link-group-${linkGroup.title}`}
        {...linkGroup}
      />
    ));
  };

  return (
    <Stack
      columns={7}
      direction='row'
      justify='space-between'
      align='flex-start'
      gap='spacing-4xl'
      hideOn='lg'
    >
      <FooterLinksStack
        direction='column'
        gap='spacing-4xl'
        justify='space-between'
        align='flex-start'
        textColor='text-quaternary-on-brand'
      >
        {renderLinkGroups([PRODUCT_LINKS, MIGHTY_PRO_LINKS])}
      </FooterLinksStack>
      <FooterLinksStack
        direction='column'
        gap='spacing-4xl'
        justify='space-between'
        align='flex-start'
        textColor='text-quaternary-on-brand'
      >
        {renderLinkGroups([RESOURCES_LINKS])}
      </FooterLinksStack>
      <FooterLinksStack
        direction='column'
        gap='spacing-4xl'
        justify='space-between'
        align='flex-start'
        textColor='text-quaternary-on-brand'
      >
        {renderLinkGroups([COMPANY_LINKS, COMPARISON_LINKS])}
      </FooterLinksStack>
      <FooterLinksStack
        direction='column'
        gap='spacing-4xl'
        justify='space-between'
        align='flex-start'
        textColor='text-quaternary-on-brand'
        flex='0 0 136px'
      >
        <Stack
          direction='column'
          gap='spacing-lg'
          align='flex-start'
          justify='flex-start'
        >
          <Typography
            size='sm'
            fontWeight='font-weight-semibold'
            color='text-primary-on-brand'
            type='paragraph'
          >
            Get the app
          </Typography>
          <AppStoreBadge />
          <GooglePlayBadge />
        </Stack>
      </FooterLinksStack>
    </Stack>
  );
};

export default FooterLinks;
